<template>
  <div class="student-selector">
    <el-select
      v-model="selectedValue"
      :placeholder="placeholder"
      :multiple="multiple"
      :clearable="clearable"
      :disabled="disabled"
      :loading="loading"
      filterable
      @change="handleChange"
    >
      <el-option
        v-for="student in students"
        :key="student.id"
        :label="`${student.studentId} - ${student.name}`"
        :value="valueKey ? student[valueKey] : student.id"
      >
        <div class="student-option">
          <span class="student-id">{{ student.studentId }}</span>
          <span class="student-name">{{ student.name }}</span>
          <el-tag size="small" :type="student.gender === '男' ? 'primary' : 'danger'">
            {{ student.gender }}
          </el-tag>
          <el-tag v-if="student.groupId || student.groupNumber" size="small" type="success">
            {{ student.groupNumber || student.groupId }}组
          </el-tag>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { ElMessage } from 'element-plus';

const props = defineProps({
  modelValue: {
    type: [Number, String, Array],
    default: () => []
  },
  classId: {
    type: [Number, String],
    required: true
  },
  placeholder: {
    type: String,
    default: '请选择学生'
  },
  multiple: {
    type: Boolean,
    default: false
  },
  clearable: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  valueKey: {
    type: String,
    default: 'id'
  }
});

const emit = defineEmits(['update:modelValue', 'change']);

const students = ref([]);
const selectedValue = ref(props.modelValue);
const loading = ref(false);

// 监听modelValue变化
watch(() => props.modelValue, (newVal) => {
  selectedValue.value = newVal;
});

// 监听选择值变化
watch(selectedValue, (newVal) => {
  emit('update:modelValue', newVal);
});

// 处理选择变更
const handleChange = (value) => {
  emit('change', value);
};

// 获取班级学生列表
const fetchStudents = async () => {
  try {
    loading.value = true;
    // TODO: 这里需要通过props传入获取学生数据的方法
    // 或者在使用组件的地方通过事件来获取数据
    // TODO: 实现学生数据获取逻辑
    students.value = [];
  } catch (error) {
    ElMessage.error('获取学生列表失败');
    console.error('获取学生列表失败:', error);
  } finally {
    loading.value = false;
  }
};

// 监听班级ID变化
watch(() => props.classId, (newVal, oldVal) => {
  if (newVal && newVal !== oldVal) {
    fetchStudents();
  }
});

onMounted(() => {
  if (props.classId) {
    fetchStudents();
  }
});
</script>

<style scoped>
.student-selector {
  width: 100%;
}

.student-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.student-id {
  font-weight: bold;
  min-width: 60px;
}

.student-name {
  flex: 1;
}
</style> 